<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">
      {{ "WORKFLOW_DIALOGS.START_WITH_CREDIT.TITLE" | translate }}
    </h1>
  </ng-template>
  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{
        "WORKFLOW_DIALOGS.START_WITH_CREDIT.DESCRIPTION"
          | translate
            : {
                fees,
              }
      }}
    </div>
  </ng-template>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="dataLoading || loading"
      [loading]="loading"
      (click)="submit()"
    >
      {{ "WORKFLOW_DIALOGS.START_WITH_CREDIT.SUBMIT" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      mat-dialog-close
      [isBorderButton]="true"
    >
      {{ "WORKFLOW_DIALOGS.START_WITH_CREDIT.CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
